import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const LANGUAGES = ['ar', 'en', 'fr'];
const LANG_LABELS = { ar: 'العربية', en: 'English', fr: 'Français' };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('tababa_lang');
    return saved && LANGUAGES.includes(saved) ? saved : 'ar';
  });

  useEffect(() => {
    localStorage.setItem('tababa_lang', language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const setLang = (lang) => {
    if (LANGUAGES.includes(lang)) setLanguage(lang);
  };

  const cycleLanguage = () => {
    const idx = LANGUAGES.indexOf(language);
    setLanguage(LANGUAGES[(idx + 1) % LANGUAGES.length]);
  };

  // t supports 2 or 3 args: t(ar, en) or t(ar, en, fr)
  const t = (ar, en, fr) => {
    if (language === 'ar') return ar;
    if (language === 'fr') return fr || en;
    return en;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: setLang, cycleLanguage, toggleLanguage: cycleLanguage, t, languages: LANGUAGES, labels: LANG_LABELS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
